import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { Shell } from './core/layout/shell';
import { authRoutes } from './auth/auth.routes';
import { bacteriologiaRoutes } from './bacteriologia/bacteriologia.routes';
import { leptospirosisRoutes } from './leptospirosis/leptospirosis.routes';
import { eebRoutes } from './eeb/eeb.routes';
import { ixodologiaRoutes } from './ixodologia/ixodologia.routes';
import { reproduccionRoutes } from './reproduccion/reproduccion.routes';
import { parasitologiaRoutes } from './parasitologia/parasitologia.routes';
import { rabiaRoutes } from './rabia/rabia.routes';
import { biologiaMolecularRoutes } from './biologia-molecular/biologia-molecular.routes';
import { catalogosRoutes } from './catalogos/catalogos.routes';
import { hematologiaRoutes } from './hematologia/hematologia.routes';
import { inicioRoutes } from './inicio/inicio.routes';
import { plantillasRoutes } from './plantillas/plantillas.routes';
import { recepcionesRoutes } from './recepciones/recepciones.routes';
import { resultadosRoutes } from './resultados/resultados.routes';
import { separacionRoutes } from './separacion/separacion.routes';
import { serologiaRoutes } from './serologia/serologia.routes';
import { serviciosRoutes } from './servicios/servicios.routes';
import { usuariosRoutes } from './usuarios/usuarios.routes';
import { virologiaRoutes } from './virologia/virologia.routes';

/**
 * Páginas de la app (dentro del armazón autenticado). Cada módulo declara sus
 * rutas en su propio `*.routes.ts`; aquí solo se agregan, más el redirect
 * inicial y el comodín. Así, al sumar pantallas, cada quien toca su archivo.
 */
const rutasApp: Routes = [
  // Aterrizaje por defecto. Quien no tenga `inicio.ver` no se queda varado:
  // el permisoGuard lo lleva a su primera pantalla permitida.
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  // Queda como respaldo: desde que el tablero de inicio es público para toda
  // sesión, `primeraRutaPermitida` siempre encuentra destino y el permisoGuard
  // ya no manda a nadie aquí.
  {
    path: 'sin-acceso',
    loadComponent: () =>
      import('./auth/pages/sin-acceso/sin-acceso.page').then((m) => m.SinAccesoPage),
    title: 'SiLabVet | Sin permisos',
  },
  ...inicioRoutes,
  ...catalogosRoutes,
  ...serviciosRoutes,
  ...plantillasRoutes,
  ...usuariosRoutes,
  ...recepcionesRoutes,
  ...separacionRoutes,
  ...serologiaRoutes,
  ...hematologiaRoutes,
  ...virologiaRoutes,
  ...biologiaMolecularRoutes,
  ...bacteriologiaRoutes,
  ...leptospirosisRoutes,
  ...rabiaRoutes,
  ...eebRoutes,
  ...ixodologiaRoutes,
  ...reproduccionRoutes,
  ...parasitologiaRoutes,
  ...resultadosRoutes,
  { path: '**', redirectTo: 'inicio' },
];

export const routes: Routes = [
  // Páginas públicas del SSO (sin armazón).
  ...authRoutes,
  // Aplicación protegida: todo cuelga del armazón y exige sesión.
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: rutasApp,
  },
];
